module.exports = __webpack_public_path__ + "static/bride-heart-f4d348d40c70ba201ab67d7d2af8f34b.svg";